import * as React from 'react'

import {useIsAgentsPartSelected} from '../../../../../hooks/routes'
import {UserProperties} from '../../../../../utils/userProperties'
import {useNewFeatureProperty} from '../../../../common/NewFeaturePopup/NewFeaturePopup.hook'
import {headerAgentsLinkHint} from '../../../../packages/Hints/HintItems/Hints.navigation'
import {useHint} from '../../../../packages/Hints/Hints.hooks'
import AgentNewFeaturePopup from '../../../../pages/PipelinesPages/AgentsPage/AgentNewFeaturePopup/AgentNewFeaturePopup'
import {LINKS} from '../../Header.consts'
import HeaderLinkHost from '../LinkHost/LinkHost'

function PipelineAgentsLink() {
  useHint(headerAgentsLinkHint)
  const agentsPartSelected = useIsAgentsPartSelected()
  const [_, setFeatureAsSeen] = useNewFeatureProperty(
    UserProperties.HAS_PIPELINE_AGENT_PAGES_BEEN_SEEN,
  )

  return React.useMemo(
    () => (
      <>
        <HeaderLinkHost
          active={agentsPartSelected}
          title={'Agents'}
          to={LINKS.agents}
          onClick={setFeatureAsSeen}
          icon="agents-20px"
        >
          {'Agents'}
        </HeaderLinkHost>
        <AgentNewFeaturePopup />
      </>
    ),
    [agentsPartSelected, setFeatureAsSeen],
  )
}

export default React.memo(PipelineAgentsLink)
